var map = {
	"./anetplus_lhs": 68783,
	"./anetplus_lhs.json": 68783,
	"./bankofamerica_lhs": 23610,
	"./bankofamerica_lhs.json": 23610,
	"./barclays_lhs": 48856,
	"./barclays_lhs.json": 48856,
	"./cybs_lhs": 57466,
	"./cybs_lhs.json": 57466,
	"./nab_lhs": 73218,
	"./nab_lhs.json": 73218,
	"./payzli_lhs": 93494,
	"./payzli_lhs.json": 93494,
	"./vas_lhs": 88965,
	"./vas_lhs.json": 88965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10936;